

export enum DashboardStudyViewerMode {
  Surface = 'surface',
  SurfaceWithProfile = 'surface_with_profile',
  Scan = 'scan',
  ScanWithDraw = 'scan_with_draw',
}
